import { Injectable } from '@angular/core';

import { BaseStorage } from '../../core/abstractions/base.storage';
import { OptionalType } from '../../models/types/optional.type';

@Injectable({
    providedIn: 'root'
})
export class SettingsStorage extends BaseStorage {
    private userLanguage = 'userLanguage';

    constructor() {
        super('settings');
    }

    saveCurrentLanguage(userLanguage: string): void {
        this.save(userLanguage, this.userLanguage);
    }

    getCurrentLanguage(): OptionalType<string> {
        return this.get<string>(this.userLanguage);
    }
}
